module.exports = __webpack_public_path__ + "assets/img/chevron-down.df90f293.svg";